<template>
    <div style="align-items: center; text-align: center;">
        <h1>This is our hero Bawl_Zapher</h1>

        <img 
            src="../assets/Bawl.webp" 
            alt="BAwl" 
            height="788px" width="620px"
            usemap="#zapher"
        >

        <map name="zapher">
            <area target="_blank" alt="reddit" title="reddit" href="https://www.reddit.com/r/bawl_zapher/" coords="388,22,24" shape="circle">
            <area target="_self" alt="List" title="List" href="https://convention-list.pages.dev/#/list" coords="218,450,542,482,542,758,136,706" shape="poly">
            <area target="_self" alt="Wiki" title="Wiki" href="https://convention-list.pages.dev/#/zapherwiki" coords="306,52,376,76,400,110,414,196,426,266,382,398,310,426,250,400,196,286,208,196,222,106,246,68" shape="poly">
            <area target="_self" alt="Home" title="Home" href="https://convention-list.pages.dev/#/" coords="72,368,0,468,0,780,58,752,96,680,86,526,138,528,158,508,154,482,84,470,86,398,114,358" shape="poly">   
        </map>
        
        <h3>Biggest Supporters</h3>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th>Supporter</th>
                    <th>Quote</th>
                    <th>Skill</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Eka</td>
                    <td>
                        "lord of the dingalings, that is my title <br>
                        im beating his dick while im reading the bible<br>
                        20:13 put that booty to death<br>
                        i murdered his buttcheeks, watch it take its last breath"
                    </td>
                    <td>Editor</td>
                </tr>
                <tr>
                    <td>Microwave</td>
                    <td>"It can always get worse"</td>
                    <td>Good at videogames</td>
                </tr>
                <tr>
                    <td>Arbie</td>
                    <td>"king of mischievous mouth is a quote from me while talking about the 2024 Denzel Curry mixtape <br>"King Of The Mischievous South Vol. 2" a hit globally, having songs like "G'Z UP (with 2 Chains, Mike Dimes)" <br>"HOT ONE (with TiaCorine and A$AP Ferg)". Truly marking a new direction in Mr. Curry's Discography"</td>
                    <td>Bad at everything</td>
                </tr>
                <tr>
                    <td>Ligarto</td>
                    <td>"If it plays like ass it's probably Future Funk II"</td>
                    <td>Coding ig</td>
                </tr>
                <tr>
                    <td>Sunward</td>
                    <td>"i poked his private parts"<br>"i poked every single inch of his body"</td>
                    <td>Turbo Autism</td>
                </tr>
            </tbody>
        </table>
    </div>
    
</template>